module.exports = __webpack_public_path__ + "static/images/components/ButtonTiny/images/default-borders-hover.bf638910.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonTiny/images/default-borders-hover.png
// module id = 2574
// module chunks = 11